import ScrollBooster from "scrollbooster";

document.addEventListener("DOMContentLoaded", function () {
  const viewports = document.querySelectorAll(".js-scroll-booster");
  if (viewports) {
    viewports.forEach(function (viewport) {
      new ScrollBooster({
        viewport: viewport,
        scrollMode: "native",
        direction: "horizontal",
        bounce: false,
        emulateScroll: true,
      });
    });
    if (navigator.platform.indexOf("Mac") !== -1) {
      viewports.forEach(function (viewport) {
        viewport.setAttribute("style", "overflow-x:auto");
      });
    }
  }
});
